import { useLayoutEffect, useState } from "react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { changeCurrency, exitMarketAction } from "../../redux/actions/currenciesActions";
import { realTimeTransactionsHeaderList } from "../../staticData/transactions";
import { calcLiveProfit, toFixed } from "../../utils/common-functions";

const RealTimeTable = ({}) => {
    const { currenciesList, isDarkMode, currentCurrencyId } = useSelector(
        (state) => state.persistedReducer
    );
    const dispatch = useDispatch();
    const inValidValues = [undefined, "undefined", null, NaN, Infinity, -Infinity];
    const [initialWidth, setInitialWidth] = useState(0);

    useLayoutEffect(() => {
        setInitialWidth(96 * 9);
    }, []);
    return (
        <div
            className={""}
            style={{
                minWidth: initialWidth
            }}>
            <div className={`${isDarkMode ? "bg-secondaryDark " : "bg-secondaryLight "}`}>
                <div className="flex  items-center flex-1">
                    {Object.values(realTimeTransactionsHeaderList).map((header, index) => {
                        return (
                            <>
                                <div
                                    key={index}
                                    className={`py-2 flex-1 min-w-16 text-svsm text-center flex items-center justify-center lg:text-sm min-h-11`}>
                                    {header}
                                </div>
                            </>
                        );
                    })}
                </div>
            </div>
            <div className={""}>
                {Object.values(currenciesList).map((currency) => {
                    if (!currency?.operations?.isBinanceOn) return null;

                    const currencyId = currency.currencyId;
                    const symbol = currency.currencyDesc;
                    const marketPrice = currency.marketPrice;

                    const candleClosePrice = currency?.realTimeStatus?.candleClosePrice;
                    const entrySide = currency?.realTimeStatus?.entrySide;

                    const activePosition = currency?.totalStatus?.activePosition;
                    const indexZero = currency?.totalStatus?.indexZero;
                    const isPositionOpen = currency?.totalStatus?.isPositionOpen;

                    const isBinanceOn = currency?.operations?.isBinanceOn;
                    const isTradeOn = currency?.operations?.isTradeOn;

                    const leverage = currency?.BUY?.walletConfig?.leverage;
                    const quantity = currency?.BUY?.walletConfig?.quantity;

                    const hasValidPosition = activePosition && activePosition !== "NO POSITION";

                    const ProfitPercentage = calcLiveProfit({
                        type: "PERCENTAGE",
                        marketPrice,
                        candleClosePrice,
                        entrySide,
                        leverage,
                        quantity
                    });

                    const ProfitDollars = calcLiveProfit({
                        type: "DOLLAR",
                        marketPrice,
                        candleClosePrice,
                        entrySide,
                        leverage,
                        quantity
                    });

                    const showProfitPercentage =
                        hasValidPosition &&
                        typeof ProfitPercentage === "number" &&
                        !inValidValues.includes(ProfitPercentage);

                    const showProfitDollars =
                        hasValidPosition &&
                        typeof ProfitDollars === "number" &&
                        !inValidValues.includes(ProfitDollars);

                    const showCandleClose =
                        hasValidPosition &&
                        typeof candleClosePrice === "number" &&
                        !inValidValues.includes(candleClosePrice);

                    const rowClasses = `min-h-12 border-b-1 border-t-1 items-center flex flex-1 ${
                        currencyId === currentCurrencyId ? "font-bold" : ""
                    } even:${isDarkMode ? "bg-secondaryDark" : "bg-secondaryLight"} ${
                        isDarkMode ? "even:text-black" : "even:text-black"
                    }`;

                    return (
                        <div key={currencyId} className={rowClasses}>
                            <div
                                className="flex-1 text-center text-vsm lg:text-sm cursor-pointer h-full min-h-12 flex items-center justify-center"
                                onClick={() => dispatch(changeCurrency(currencyId))}>
                                {symbol}
                            </div>
                            <div className="flex-1 text-center text-vsm lg:text-sm">
                                {marketPrice}
                            </div>
                            <div className="flex-1 text-center text-vsm lg:text-sm h-full min-h-12 flex items-center justify-center">
                                {hasValidPosition ? entrySide : ""}
                            </div>
                            <div className="flex-1 text-center text-vsm lg:text-sm h-full min-h-12 flex items-center justify-center">
                                {showCandleClose ? toFixed(candleClosePrice, 5) : ""}
                            </div>
                            <div className="flex-1 text-center text-vsm lg:text-sm text-white h-full min-h-12 flex items-center justify-center">
                                <div
                                    className={`w-2/3 min-h-8 flex justify-center items-center rounded-full ${
                                        showProfitPercentage
                                            ? ProfitPercentage > 0
                                                ? "bg-secondaryGreen"
                                                : "bg-secondaryRed"
                                            : ""
                                    }`}>
                                    {showProfitPercentage ? toFixed(ProfitPercentage, 2) : ""}
                                </div>
                            </div>
                            <div className="text-white flex-1 text-center text-vsm lg:text-sm h-full min-h-12 flex items-center justify-center">
                                <div
                                    className={`w-2/3 min-h-8 flex justify-center items-center rounded-full ${
                                        showProfitDollars
                                            ? ProfitDollars > 0
                                                ? "bg-secondaryGreen"
                                                : "bg-secondaryRed"
                                            : ""
                                    }`}>
                                    {showProfitDollars ? toFixed(ProfitDollars, 2) : ""}
                                </div>
                            </div>
                            <div className="flex-1 text-center text-vsm lg:text-sm w-8 rounded-full text-white h-full min-h-12 flex items-center justify-center">
                                <div
                                    className={`h-3/4 w-1/6 rounded-full ${
                                        isTradeOn ? "bg-secondaryGreen" : "bg-secondaryRed"
                                    } border-1 flex justify-center`}>
                                    {isTradeOn ? "✓" : "x"}
                                </div>
                            </div>
                            <div className="flex-1 flex justify-center items-center text-sm">
                                {isPositionOpen
                                    ? Intl.DateTimeFormat().resolvedOptions().timeZone ===
                                      "Asia/Tehran"
                                        ? moment(indexZero).subtract(1, "hour").fromNow()
                                        : moment(indexZero).fromNow()
                                    : ""}
                            </div>
                            <div
                                className={`flex-1 text-center text-vsm lg:text-sm h-full min-h-12 flex items-center justify-center ${
                                    entrySide
                                        ? "hover:bg-primaryRed hover:text-white cursor-pointer"
                                        : ""
                                }`}
                                onClick={() =>
                                    entrySide &&
                                    dispatch(
                                        exitMarketAction({
                                            currentCurrencyId: currencyId,
                                            entrySide,
                                            storeInDb: true,
                                            binanceMode: isTradeOn
                                        })
                                    )
                                }>
                                {entrySide ? "market" : ""}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default RealTimeTable;
